import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { ReportFlaggedContentModalComponent } from "./CompassModal/ReportFlaggedContentModalComponent";

type ReportFlaggedContentModalComponentProps = Omit<
  ComponentPropsWithoutRef<typeof ReportFlaggedContentModalComponent>,
  "open" | "onOpenChange"
>;

const ReportFlaggedContentModal = ModalManager.create(
  (props: ReportFlaggedContentModalComponentProps) => {
    const modal = useModal();

    return (
      <ReportFlaggedContentModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const useReportFlaggedContentModal = () =>
  useModal(ReportFlaggedContentModal);
